import { FC, ReactNode } from 'react'
import { Disclosure } from '@headlessui/react'
import tw from 'twin.macro'
import { ChevronDown, ChevronUp } from 'react-feather'
import { SubHeader } from './UI'
import FeatherIcon from './FeatherIcon'
import { FeatherIconType } from '../types/icon'

type Props = {
  header: string
  content: ReactNode
  icon?: FeatherIconType
  indexString?: string
  topBorder: boolean
}

const Dropdown: FC<Props> = ({
  header,
  content,
  icon,
  indexString,
  topBorder,
}) => {
  return (
    <Disclosure>
      {({ open }) => (
        <div
          css={[
            tw`w-full`,
            topBorder && tw`border-t border-white`,
            open && tw`pb-[21px]`,
          ]}
        >
          <Disclosure.Button
            css={[tw`w-full py-[21px] flex justify-start items-start`]}
          >
            {icon && (
              <FeatherIcon
                icon={icon}
                cssStyle={[tw`w-8 mr-2`, !!indexString && tw`mt-[28px]`]}
              />
            )}
            <div tw="w-full">
              {!!indexString && <div tw="mb-1.5 text-left">{indexString}</div>}
              <h4 css={[SubHeader, tw`text-left`]}>{header}</h4>
            </div>
            {open ? <ChevronUp tw="w-6" /> : <ChevronDown tw="w-6" />}
          </Disclosure.Button>
          <Disclosure.Panel css={[tw`pb-[12px]`, !!icon && tw`pl-[40px]`]}>
            {content}
          </Disclosure.Panel>
        </div>
      )}
    </Disclosure>
  )
}

export default Dropdown

type DropdownUnopenableProps = Omit<Props, 'content'>

export const DropdownUnopenable: FC<DropdownUnopenableProps> = ({
  header,
  icon,
  indexString,
  topBorder,
}) => {
  return (
    <div css={[tw`w-full`, topBorder && tw`border-t border-white`]}>
      <div tw="w-full py-[21px] flex justify-start items-start">
        {icon && (
          <FeatherIcon
            icon={icon}
            cssStyle={[tw`w-8 mr-2`, !!indexString && tw`mt-[28px]`]}
          />
        )}
        <div tw="w-full">
          {!!indexString && <div tw="mb-1.5 text-left">{indexString}</div>}
          <h4 css={[SubHeader, tw`text-left`]}>{header}</h4>
        </div>
      </div>
    </div>
  )
}
